module.exports = __webpack_public_path__ + "media/images/common/logo_bg_05-8e923baf3aba38cc9728012ed7321839.png";